<template>
  <div class="denomination-search-wrapper flex flex-row" :class="`bg-${color}`">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="position: absolute;text-align: center;margin: 10px;"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C7.23858 0 5 2.23858 5 5C5 6.86059 6.01627 8.48382 7.52399 9.34488C3.75742 10.4204 1 13.8882 1 18C1 18.3801 1.02362 18.7552 1.06958 19.1237L1.17885 20H18.8212L18.9304 19.1237C18.9764 18.7552 19 18.3801 19 18C19 13.8882 16.2426 10.4204 12.476 9.34488C13.9837 8.48382 15 6.86059 15 5C15 2.23858 12.7614 0 10 0ZM7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5ZM3 18C3 14.134 6.13401 11 10 11C13.866 11 17 14.134 17 18H3Z"
        fill="white"
      />
    </svg>

    <Listbox v-model="selectedDenomination" v-slot="{ open }">
      <div class="relative mx-auto my-auto">
        <ListboxButton
          class="relative w-full py-2 pl-3 pr-10 text-left bg-white rounded-full shadow-md cursor-default focus:outline-none focus-visible:ring-white  sm:text-sm"
          style="width: 416px; padding-bottom: 2px; padding-top: 2px;"
        >
          <span
            class="block truncate text-lg"
            :class="selectedDenomination ? `text-${color}` : 'text-gray-500'"
            >{{
              selectedDenomination
                ? selectedDenomination.name
                : '会派もしくは議員を選択ください'
            }}</span
          >
          <span
            class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
          >
            <chevron-icn
              width="20px"
              height="20px"
              :class="`${color}-icon`"
              :style="open ? 'transform: rotate(180deg)' : ''"
            ></chevron-icn>
            <!-- <SelectorIcon class="w-5 h-5 text-gray-400" aria-hidden="true" /> -->
          </span>
        </ListboxButton>

        <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions
            class="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            style="border-radius: 20px; outline: 2px solid white; padding-left: 2px; padding-right: 2px;"
            :class="`border-4 border-${color}`"
          >
            <ListboxOption
              v-slot="{ active, selected }"
              v-for="denomination in denominations"
              :key="denomination.id"
              :value="denomination"
              as="template"
            >
              <li
                :class="[
                  active ? `bg-${color} text-white active` : `text-${color}`,
                  'cursor-default select-none relative pl-8',
                ]"
                style="height: 28px;"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="absolute inset-y-0 left-0 flex items-center"
                  style="margin: auto; margin-left: 6px;"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14 5C14 7.20914 12.2091 9 10 9C7.79086 9 6 7.20914 6 5C6 2.79086 7.79086 1 10 1C12.2091 1 14 2.79086 14 5ZM13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5Z"
                    fill="#2993CE"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 18C18 18.3387 17.979 18.6724 17.9381 19H2.06189C2.02104 18.6724 2 18.3387 2 18C2 13.5817 5.58172 10 10 10C14.4183 10 18 13.5817 18 18ZM10 11C13.866 11 17 14.134 17 18H3C3 14.134 6.13401 11 10 11Z"
                    fill="#2993CE"
                  />
                </svg>

                <span
                  :class="[
                    selected ? 'font-medium' : 'font-normal',
                    'block truncate text-lg',
                  ]"
                  >{{ denomination.name }}</span
                >
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>

    <clear-icn
      class="clear-icon"
      width="20px"
      height="20px"
      @click="clearSearch"
    ></clear-icn>
  </div>
</template>
<script>
import { ref } from 'vue'
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'
import ClearIcn from '@/assets/icons/clear.svg?inline'
import ChevronIcn from '@/assets/icons/chevron.svg?inline'

export default {
  name: 'AppDenominationSearch',

  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ClearIcn,
    ChevronIcn,
  },

  props: {
    color: {
      type: String,
      default: '',
    },
  },

  setup() {
    const denominations = [
      {
        id: 3,
        name: 'Kitano and Co',
        representative_id: 4,
        is_lonely: false,
        start_date: '2121-03-03 00:00:00',
        end_date: '2121-03-03 00:00:00',
        editor_id: 23,
      },
      {
        id: 5,
        name: 'Kanazawa Diet',
        representative_id: 11,
        is_lonely: true,
        start_date: '2121-03-03 00:00:00',
        end_date: '2121-03-03 00:00:00',
        editor_id: 15,
      },
    ]

    const selectedDenomination = ref(null)

    const clearSearch = () => {
      selectedDenomination.value = null
    }

    return { denominations, selectedDenomination, clearSearch }
  },
}
</script>
<style lang="scss" scoped>
.denomination-search-wrapper {
  position: relative;
  width: 488px;
  height: 40px;
  box-sizing: border-box;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  svg.clear-icon {
    position: absolute;
    right: 0px;
    margin: 10px;
  }
}

li.active {
  border-radius: 22px;
  svg {
    path {
      fill: white;
    }
  }
}
</style>
